import { render, staticRenderFns } from "./ForeignEnterprises.vue?vue&type=template&id=ea10f598&"
import script from "./ForeignEnterprises.vue?vue&type=script&lang=js&"
export * from "./ForeignEnterprises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports